import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import toastr from 'toastr';
import Constants from '../../../definitions/constants';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as resetPasswordActions from '../../actions/resetPassword/index';

/*Components*/
import ResetPasswordForm from '../../components/resetPassword/resetPasswordForm';

/*Styles*/
import '../../../../public/style/main.scss';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        newPassword: '',
        newPasswordRepeat: ''
      },
    };
  }
  
  componentDidUpdate(prevProps) {
    //manage toastr errors
    if (prevProps.reset.status !== 200 && this.props.reset.status === 200) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.success(
        intl.formatMessage({ id: "login.resetPassword.feedbackMessages.passwordResetOk.info" }), 
        intl.formatMessage({ id: "login.resetPassword.feedbackMessages.passwordResetOk.title" })
      );
    }
  }

  handleResetPassword = async event => {
    event.preventDefault();
    await this.props.actions.resetPassword({
      user: {
        reset_password_token: this.props.match.params.resetToken,
        password: this.state.formData.newPassword,
        password_confirmation: this.state.formData.newPasswordRepeat
      }
    });
  };

  handleOnChange = event => {
    let formData = { ...this.state.formData };
    formData[event.target.id] = event.target.value;
    
    this.setState({
      formData
    });
  };

  render() {
    return (
      <div className="reset_password_view login_view">
        <ResetPasswordForm
          errors={this.props.reset.errors}
          handleResetPassword={this.handleResetPassword}
          handleOnChange={this.handleOnChange}
          status={this.props.reset.status}
          loading={this.props.reset.loading}
          formData={this.state.formData}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  reset: state.reducer.resetPassword.reset
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(resetPasswordActions, dispatch)
});

ResetPassword.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./source/client/containers/resetPassword/index.jsx